import { of, switchMap, tap } from 'rxjs';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { ServiceSelectionChangedEvent } from '@platform/event-bus/domain/events/service-selection-change.event';
import { SERVICE_STATE_SERVICE } from '@features/service/domain/tokens/service-state.token';
import { ServiceRedirectPort } from '@features/service/domain/port/service-redirect.port';



@Injectable({ providedIn: 'root' })
export class PlatformOnServiceSelectionSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly serviceStateService = inject(SERVICE_STATE_SERVICE);
  private readonly redirect = inject(ServiceRedirectPort);

  constructor() {
    this.eventBus.ofType(ServiceSelectionChangedEvent).pipe(
      switchMap((event) => {
        const payload = event.payload;

        if(!payload){
          this.serviceStateService.removeCurrentLocation();
          this.serviceStateService.removeCurrentDrawer();
          this.serviceStateService.removeCurrentWorker();

          return of(null);
        }

        if (payload.location) {
          this.serviceStateService.setCurrentLocation(payload.location);
        }

        if (payload.drawer) {
          this.serviceStateService.setCurrentDrawer(payload.drawer);
        }

        if (payload.worker) {
          this.serviceStateService.setCurrentWorker(payload.worker);
        }

        return of(null);
      }),
      tap(() => {
        const location = this.serviceStateService.getCurrentLocation();
        const drawer = this.serviceStateService.getCurrentDrawer();
        const worker = this.serviceStateService.getCurrentWorker();

        if (!location && !drawer && !worker) {
          this.redirect.goToServiceConfiguration();
        }
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}
